import { useContext } from "react";
import { ResourceContext } from "./ResourceProvider";
import type { ResourceContext as ResourceContextType } from "./types";

export default function useResourceContext<TResource>() {
    return useContext(ResourceContext) as ResourceContextType<TResource>;
};
